import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface Props {
  onChange?(values: string[]): void;
}

export function UserTypeInput({ onChange }: Props) {
  const { t } = useTranslation();
  const allUserTypes = ["Benutzer", "Fahrer"];

  return (
    <Autocomplete
      id="user-search"
      size="small"
      limitTags={1}
      multiple
      onChange={(_, value) => onChange?.(value ?? undefined)}
      fullWidth
      disableCloseOnSelect
      options={allUserTypes}
      renderInput={params => (
        <TextField
          {...params}
          label={t("licenseCheckAdmin.userType", "User Type")}
          placeholder={t("licenseCheckAdmin.userTypePlaceholder", "Search for User Type")}
        />
      )}
    />
  );
}
